export default __webpack_public_path__ + "static/media/FRAX.e43116e9.svg";